import React, { Component } from 'react'
import UserBlock from '../Users/UserBlock.js'
import './evaluations.css'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import TitleBar from '../TitleBar'

export default class SessionEvaluation extends Component {
  constructor(props) {
    super(props)
    var session = _.find(this.props.sessions.sessions, {id: parseInt(props.match.params.id, 10)})
    if(session.evaluation_completed) {
      if(this.props.match.params.type === 'evaluations'){
        this.props.history.push('/evaluations')
      } else {
        this.props.history.push('/session/' + session.id)
      }
    }
    this.state = {
      session: session,
      commentText: '',
      OverallRating: 0,
      requestFollowup: null,
    }
    this.handleRadio = this.handleRadio.bind(this)
    this.props.setActiveTab('evaluations', false)
    window.trackPage('EvaluationSessionDetailScreen', props.match.params.id)
  }

  componentDidMount() {
    // scroll to top
    window.scrollTo(0,0)
  }


  updateComment(e){
    this.setState({
      commentText: e.target.value
    })
  }

  getUserFromUserID(user_id) {
    return _.find(this.props.users.event_users, {user_id: parseInt(user_id, 10)})
  }

  star(speaker, number) {
    if(speaker) {
      speaker.number = number
    } else {
      this.setState({OverallRating: number})
    }
    this.forceUpdate()
  }

  getSpeakers() {
    const speakers = []
    _.each(this.state.session.event_session_speakers, (speaker, counter) => {
      const user = this.getUserFromUserID(speaker.user_id)
      if(user) {
        speakers.push(
          <div key={speaker.id}>
            <UserBlock user={user} noHover={true} />
            <div className="margin-bottom-10" data-test-class='speaker_rating' data-test-id={counter} >
              <i onClick={() => this.star(speaker, 1)} className={(speaker.number >= 1 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
              <i onClick={() => this.star(speaker, 2)} className={(speaker.number >= 2 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
              <i onClick={() => this.star(speaker, 3)} className={(speaker.number >= 3 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
              <i onClick={() => this.star(speaker, 4)} className={(speaker.number >= 4 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
              <i onClick={() => this.star(speaker, 5)} className={(speaker.number >= 5 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
            </div>
          </div>
        )
      }
    })
    return speakers
  }

  submit(e) {
    let unratedSpeaker = false
    let speakers = _.map(this.state.session.event_session_speakers, function(speaker){
      if(speaker.number === undefined || speaker.number === 0){
        unratedSpeaker = true
      }
      return {event_session_speaker_id: speaker.id, rating: speaker.number}
    })
    e.currentTarget.disabled = true
    if(this.state.OverallRating === undefined || this.state.OverallRating === 0 ) {
      this.props.flashMessage({
        message: getLabel('session_rating_required'),
        type: 'error'
      })
      e.currentTarget.disabled = false
    } else if (unratedSpeaker) {
      this.props.flashMessage({
        message: getLabel('session_speaker_rating_required'),
        type: 'error'
      })
      e.currentTarget.disabled = false
    } else {
      var data = {
        event_session_survey:
          {
          	event_session_id: this.state.session.id,
          	rating: this.state.OverallRating,
          	comments: this.state.commentText,
          	event_session_survey_speakers: speakers,
            requests_sponsor_followup: this.state.requestFollowup
          }
      }
      this.props.postResource({ key: 'session_evaluation', data: data, callback: () => {
        if(this.props.match.params.type === 'evaluations'){
          this.props.history.push('/evaluations')
        } else {
          this.props.history.push('/session/' + this.state.session.id)
        }
      }})
    }
  }

  cancel() {
    window.history.back()
  }

  handleRadio(event) {
    const boo = event.currentTarget.value === 'true' ? true: false
    this.setState({ requestFollowup: boo})
  }

  showFollowUpQuestion() {
    const requestFollowup = this.state.requestFollowup
    if (this.state.session.sponsor_id && this.state.session.is_followup_meeting_question_enabled) {
      return(
        <div className="follow-up">
          <h4>Would you like to continue the conversation with the host/speaker from this session?</h4>
          <label className="follow-up-label">
            <input
              type="radio"
              name="requestFollowup"
              value="true"
              checked={requestFollowup === true}
              onChange={this.handleRadio} />
            Yes
          </label>
          <label className="follow-up-label">
            <input
              type="radio"
              name="requestFollowup"
              value="false"
              checked={requestFollowup === false}
              onChange={this.handleRadio} />
            No
          </label>
        </div>
      )
    }
  }

  render() {
    if(!this.state.session) {
      return (
        <div>
          no session found
        </div>
      )
    } else {
      return (
        <div>
          <TitleBar title={ getLabel('eval_session') } />
          <h2>{this.state.session.name}</h2>
          <h6>{this.state.session.formatted_display_date}</h6>
          <h6>{this.state.session.room_name} -- {this.state.session.session_type}</h6>
          <br />
          <p>{getLabel('rating_instructions')}</p>
          <h4>{getLabel('session_overall_rating')}</h4>
          <i onClick={() => this.star(null, 1)} className={(this.state.OverallRating >= 1 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')} data-test='session-rating'></i>
          <i onClick={() => this.star(null, 2)} className={(this.state.OverallRating >= 2 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')} data-test='session-rating'></i>
          <i onClick={() => this.star(null, 3)} className={(this.state.OverallRating >= 3 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')} data-test='session-rating'></i>
          <i onClick={() => this.star(null, 4)} className={(this.state.OverallRating >= 4 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')} data-test='session-rating'></i>
          <i onClick={() => this.star(null, 5)} className={(this.state.OverallRating >= 5 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')} data-test='session-rating'></i>
          <br /><br />
          { (this.state.session.event_session_speakers.length > 0) && <h4>{getLabel('session_rate_speakers')}</h4> }
          {this.getSpeakers()}
          <br />
          <label>{getLabel('additional_comments')}</label>
          <textarea className="form-control" placeholder={getLabel('additional_comment_placeholder')} value={ this.state.commentText } onChange={ this.updateComment.bind(this) } />
          {this.showFollowUpQuestion()}
          <div className="center">
            <button className="standard" onClick={this.submit.bind(this)}>{getLabel('submit')}</button>
            <br />
            <button className="cancel" onClick={this.cancel.bind(this)}>{getLabel('cancel')}</button>
          </div>
        </div>
      )
    }
  }
}
